module.exports = __webpack_public_path__ + "static/img/login_bg.7c02069.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/login_bg.jpg
// module id = Lzu9
// module chunks = 0